// extracted by mini-css-extract-plugin
export var alignCenter = "_8y-d";
export var bannerShown = "_8y-6";
export var buttonContent = "_8y-0";
export var cardList = "_8y-1";
export var centerContent = "_8y-2";
export var chevron = "_8y-3";
export var closePanelButton = "_8y-k";
export var conversationContextContainer = "_8y-l";
export var conversationDetailContainer = "_8y-4";
export var detailWrapper = "_8y-7";
export var dropdownButton = "_8y-e";
export var dropdownTitle = "_8y-9";
export var fullHeight = "_8y-5";
export var hidden = "_8y-a";
export var icon = "_8y-b";
export var mergeSuggestionWrapper = "_8y-m";
export var panel = "_8y-i";
export var portalButtonsWrapper = "_8y-c";
export var right = "_8y-j";
export var tableSummaryContainer = "_8y-8";
export var tableSummaryHeader = "_8y-g";
export var threeDotsButton = "_8y-f";
export var wide = "_8y-h";